<restricted-search-callout [visible]="notAllItems" text="Too many changes; reduce period to show all.">
</restricted-search-callout>

<div class="container container-search">
    <div class="row">
        <div class="col-sm-3 form-group">
            <label>From</label>
            <ep-datetime-picker #datepickerFrom type="datetime" (selectedDatetimeChange)="dateFromChanged($event)">
            </ep-datetime-picker>
        </div>
        <div class="col-sm-3 form-group">
            <label>To</label>
            <ep-datetime-picker #datepickerTo type="datetime" (selectedDatetimeChange)="dateToChanged($event)">
            </ep-datetime-picker>
        </div>
        <div class="col-sm-4 form-group"> <!-- Leave space for the callout above -->
            <label>&nbsp;</label> <!-- dummy label to make even distance -->
            <div>
                <button class="btn btn-link" (click)="setTimeSpan('today')">Today</button>
                <button class="btn btn-link" (click)="setTimeSpan('last7days')">Last 7 days</button>
                <button class="btn btn-link" (click)="setTimeSpan('last30days')">Last 30 days </button>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-sm-12 justifyer">
            <div class="justify-item">
                <button type="button" class="btn btn-primary" (click)="search()">Search</button>
                <button type="button" class="btn btn-link" (click)="reset()">
                    <span>Reset search</span>
                    <ep-svg-icon icon="circle-cross"></ep-svg-icon>
                </button>
            </div>
        </div>
    </div>

</div>

<hr />

<div>
    <ng-content></ng-content>
</div>
